import { supabase } from '../lib/supabase';

/**
 * Service for persisting concept practice reps
 */
export const conceptsPracticeService = {
  /**
   * Log a concept practice rep
   * @param {string} userId
   * @param {string} conceptId
   * @param {boolean} understood
   * @param {string} notes
   * @returns {Promise<object>} inserted row
   */
  async logPractice(userId, conceptId, understood = false, notes = '') {
    if (!userId || !conceptId) throw new Error('Missing userId or conceptId');
    const { data, error } = await supabase
      .from('user_concepts')
      .insert({ user_id: userId, concept_id: conceptId, understood, notes })
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  /** Fetch user's concept practice records */
  async getUserConcepts(userId, limit = 50) {
    const { data, error } = await supabase
      .from('user_concepts')
      .select('*')
      .eq('user_id', userId)
      .order('completed_at', { ascending: false })
      .limit(limit);
    if (error) throw error;
    return data || [];
  }
};

export default conceptsPracticeService;
